import { apiClient } from '@/services/apiClient'
import { RdppfType, Rdppf, RdppfWithType } from '@popety-io/types'

export const rdppfService = {
  /**
   * Fetch all RDPPF restrictions for a specific region
   */
  getByRegionId: async (regionId: string): Promise<RdppfWithType[]> => {
    try {
      const response = await apiClient.get(`/rdppf/by-region/${regionId}`)
      return response.data || []
    } catch (error) {
      console.error('Error fetching RDPPF by region:', error)
      throw error
    }
  },

  /**
   * Fetch RDPPF restrictions by multiple IDs
   */
  getByIds: async (ids: string[]): Promise<RdppfWithType[]> => {
    try {
      if (!ids || ids.length === 0) {
        return []
      }

      // Join IDs as comma-separated string for query parameter
      const idsParam = ids.join(',')
      const response = await apiClient.get(`/rdppf/by-ids?ids=${idsParam}`)
      return response.data || []
    } catch (error) {
      console.error('Error fetching RDPPF by IDs:', error)
      throw error
    }
  },

  /**
   * Fetch RDPPF restrictions for a specific land parcel
   */
  getByLandId: async (land_id: string): Promise<RdppfWithType[]> => {
    try {
      const response = await apiClient.get(`/rdppf/by-land/${land_id}`)
      return response.data || []
    } catch (error) {
      console.error('Error fetching RDPPF by land ID:', error)
      throw error
    }
  },
}
